// extracted by mini-css-extract-plugin
export default {"table":"AuditLogs_table__3dd98","header":"AuditLogs_header__4jlYz","log-header":"AuditLogs_log-header__QG9ka","loading-value":"AuditLogs_loading-value__qHG2P"};